export const NOTIFIER_SHOW = 'NOTIFIER:SHOW'
export const NOTIFIER_HIDE = 'NOTIFIER:HIDE'